export default __webpack_public_path__ + "static/media/hero-center.e88c6a47.png";